// Scroll-reveal (motion pass) — flips .is-inview once per [data-reveal] element as it enters
// the viewport. Progressive enhancement: the hidden resting state (reveal stylesheet) only
// applies under html.obr-motion (added HERE, after the reduced-motion / IO capability checks),
// so no-JS, failed-JS and reduced-motion users always get fully visible content.
export function initReveal() {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return
  if (!('IntersectionObserver' in window)) return

  const els = document.querySelectorAll('[data-reveal]')
  if (!els.length) return

  document.documentElement.classList.add('obr-motion')

  const io = new IntersectionObserver((entries) => {
    for (const entry of entries) {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-inview')
        io.unobserve(entry.target)
      }
    }
  }, { threshold: 0.15, rootMargin: '0px 0px -10% 0px' })

  els.forEach((el) => io.observe(el))
}
